import { defineComponent as _defineComponent } from 'vue'
import { renderSlot as _renderSlot, resolveComponent as _resolveComponent, normalizeClass as _normalizeClass, withCtx as _withCtx, openBlock as _openBlock, createBlock as _createBlock } from "vue"


export default /*#__PURE__*/_defineComponent({
  __name: 'Tooltip',
  props: {
    delay: { default: 500 },
    offset: { default() {
    return [0, 0];
  } },
    size: { default: 'medium' }
  },
  setup(__props: any) {



return (_ctx: any,_cache: any) => {
  const _component_q_tooltip = _resolveComponent("q-tooltip")!

  return (_openBlock(), _createBlock(_component_q_tooltip, {
    class: _normalizeClass(["text-no-wrap line-height-1", { 'text-caption': __props.size === 'small', 'text-body2': __props.size === 'medium' }]),
    delay: __props.delay,
    offset: __props.offset
  }, {
    default: _withCtx(() => [
      _renderSlot(_ctx.$slots, "default")
    ]),
    _: 3
  }, 8, ["class", "delay", "offset"]))
}
}

})